import { FunctionComponent, PropsWithChildren } from "react";

const TypographyContainer: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <div className="p-3">{children}</div>;
};

export default TypographyContainer;
